import { ON_REPORTS_ORGANIZATION_CHANGE } from '../actions.js';

const initialState = {
  ownerId: '',
  currencies: []
};

export default (state = initialState, action) => {
  if (action.type === ON_REPORTS_ORGANIZATION_CHANGE) {
    return {
      ownerId: action.payload.ownerId,
      currencies: action.payload.currencies
    };
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/modules/reports/reducers/selected-organization.js